export const transitionPeriodForSpCertificate = 90;
export const transitionPeriodForIdpCertificate = 60;


// WEBPACK FOOTER //
// ./src/constants/idpAdminConstants.js